import { render, staticRenderFns } from "./BookingnoFlightDetails.vue?vue&type=template&id=22d8eade&scoped=true"
import script from "./BookingnoFlightDetails.vue?vue&type=script&lang=js"
export * from "./BookingnoFlightDetails.vue?vue&type=script&lang=js"
import style0 from "./BookingnoFlightDetails.vue?vue&type=style&index=0&id=22d8eade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d8eade",
  null
  
)

export default component.exports